(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-text-slide-in"] && !Shopify.designMode) return;
  try {
    
function initImageTextSlideSection(section) {
  // Kill any existing ScrollTriggers on this section to prevent duplicates on theme editor reloads
  ScrollTrigger.getAll().forEach(trigger => {
    if (trigger.trigger === section) {
      trigger.kill();
    }
  });

  const imageCol = section.querySelector('.image-text-slide__media-col');
  const textCol = section.querySelector('.image-text-slide__text-col');
  const desktopLayout = section.dataset.layout;
  const mobileLayout = section.dataset.mobileLayout;

  if (!imageCol || !textCol) return;

  gsap.registerPlugin(ScrollTrigger);

  // Use GSAP's matchMedia for responsive animations
  ScrollTrigger.matchMedia({

    // --- DESKTOP ANIMATION ---
    "(min-width: 768px)": function() {
      const leftEl = desktopLayout === 'image_left' ? imageCol : textCol;
      const rightEl = desktopLayout === 'image_left' ? textCol : imageCol;

      gsap.set(leftEl, { xPercent: -50, autoAlpha: 0 });
      gsap.set(rightEl, { xPercent: 50, autoAlpha: 0 });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: 'top bottom',
          end: 'center center',
          scrub: 1,
        },
        defaults: { ease: 'power2.out' }
      });
      tl.to(leftEl, { xPercent: 0, autoAlpha: 1 })
        .to(rightEl, { xPercent: 0, autoAlpha: 1 }, 0);
    },

    // --- MOBILE ANIMATION ---
    "(max-width: 767px)": function() {
      // On mobile, image ALWAYS comes from left, text ALWAYS from right.
      gsap.set(imageCol, { xPercent: -50, autoAlpha: 0 });
      gsap.set(textCol, { xPercent: 50, autoAlpha: 0 });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: 'top 95%', // Start a bit later on mobile
          end: 'center 70%', // End sooner to account for stacking
          scrub: 1,
        },
        defaults: { ease: 'power2.out' }
      });
      // Animate them horizontally at the same time
      tl.to(imageCol, { xPercent: 0, autoAlpha: 1 })
        .to(textCol, { xPercent: 0, autoAlpha: 1 }, 0);
    }
  });
}

// Standard Shopify section JS initialization
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.image-text-slide-wrapper').forEach(section => {
    initImageTextSlideSection(section);
  });
});

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('.image-text-slide-wrapper');
  if (section) {
    initImageTextSlideSection(section);
  }
});

  } catch(e) { console.error(e); }
})();
})();
